
import {
  QUOTATIONS_PAGINATOR_SET_CONFIGURATION_EMITTED_QUOTATIONS,

  QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_REQUEST,
  QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_SUCCESS,
  QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_ERROR,
} from 'Redux/types/tableQuotationsTypes';

import { BACKEND_URL_QUOTATION } from 'Config/routes';
import { CALL_ACTIONS } from 'Redux/middleware';
import { filtersToDto } from 'Api/actions/quotation/dto/filtersDto';

// ------------------------------- ------------------------------- ------------------------------- -------------------------------
// Para poner el número de página y el Page size
const configurationQuotationsEmitted = ({ page, page_size: pageSize }) => ({
  type: QUOTATIONS_PAGINATOR_SET_CONFIGURATION_EMITTED_QUOTATIONS,

  page,
  page_size: pageSize,
});

export const setConfigurationQuotationsEmitted = (data) => (dispatch) => dispatch(configurationQuotationsEmitted(data));


// ------------------------------- ------------------------------- ------------------------------- -------------------------------
// quotations EMITTED
const getQuotationsEmittedAction = (params) => ({
  [CALL_ACTIONS]: {
    TYPES: [
      QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_REQUEST,
      QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_SUCCESS,
      QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_ERROR,
    ],
    ENDPOINT: BACKEND_URL_QUOTATION,
    METHOD: 'GET',
    PARAMS: params,
  },
});

export const getQuotationsEmitted = ({ state }) => (dispatch, getState) => {
  const stateGeted = getState();
  const { page_size: pageSize, page } = stateGeted.tableQuotations.quotationsEmitted;
  const filterQuotations = stateGeted.tableQuotations.filtersTableQuotations;

  return (dispatch(getQuotationsEmittedAction({
    ...filtersToDto(filterQuotations),
    // vendedores: (filterQuotations.vendedores || []).join(','),
    // aseguradoras: (filterQuotations.aseguradoras || []).join(','),

    state,
    page_size: pageSize,
    page,
  })));
};
